import Routes from './Routes';

function App() {
	return (
		<div className='font-quicksand xl:max-w-screen-2xl lg:w-11/12 m-auto'>
			<Routes />
		</div>
	);
}

export default App;
